import { render, staticRenderFns } from "./pdfGen.vue?vue&type=template&id=10753606&scoped=true&"
import script from "./pdfGen.vue?vue&type=script&lang=js&"
export * from "./pdfGen.vue?vue&type=script&lang=js&"
import style0 from "./pdfGen.vue?vue&type=style&index=0&id=10753606&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10753606",
  null
  
)

export default component.exports